module.exports = __webpack_public_path__ + "static/media/CCR_Logo_New.5de40070.svg";